export default __webpack_public_path__ + "static/media/Dissatisfied.685dff2f.svg";